// extracted by mini-css-extract-plugin
export default {"slideshowDot":"Dots_slideshowDot__vm-hO","active":"Dots_active__K7R4n"};